function comparePosition(a, b) {
  const pa = Number.isFinite(Number(a && a.position)) ? Number(a.position) : 0;
  const pb = Number.isFinite(Number(b && b.position)) ? Number(b.position) : 0;
  return pa - pb;
}

export function orderPresentationMedia(media) {
  const source = Array.isArray(media) ? media : [];
  const ordered = source
    .filter((item) => item && item.url)
    .slice()
    .sort(comparePosition);
  const heroIndex = ordered.findIndex((item) => item.is_hero);
  const hero = heroIndex >= 0 ? ordered[heroIndex] : ordered[0] || null;
  const rest = hero ? ordered.filter((item) => item !== hero) : ordered.slice();
  return { ordered, hero, rest };
}

export function moveMediaToFront(ids, imageId) {
  const current = Array.isArray(ids) ? [...ids] : [];
  const index = current.indexOf(imageId);
  if (index < 0) return current;
  current.splice(index, 1);
  current.unshift(imageId);
  return current;
}

export {
  collectMediaCardRects,
  moveMediaByOffset,
  parseMediaId,
  reorderMediaIds,
  resolveMediaDropTargetId,
  resolveMediaIdFromPoint,
} from "../../../shared/mediaReorder/mediaReorder";

/**
 * Presentation picker visual order: selected media follow mediaIds,
 * then unselected Property images in their original source order.
 * Does not mutate images.
 */
export function orderMediaPickerImages(images, mediaIds) {
  const source = Array.isArray(images) ? images : [];
  const ids = Array.isArray(mediaIds) ? mediaIds : [];
  const byId = new Map();
  source.forEach((image) => {
    if (image && image.id != null) byId.set(image.id, image);
  });
  const selectedOrdered = [];
  const selectedSet = new Set();
  ids.forEach((id) => {
    const image = byId.get(id);
    if (!image) return;
    selectedOrdered.push(image);
    selectedSet.add(id);
  });
  const unselected = source.filter((image) => image && !selectedSet.has(image.id));
  return selectedOrdered.concat(unselected);
}
